import styled, { css } from 'styled-components'
import { Color, rem, BaseColor, spacing, textEllipsis, themeColor, Typography } from '~theme'
import { InputStyled } from '../TextualFormElement'

interface LabelTextProps {
  size: 'small' | 'medium' | 'large'
}

export const LabelText = styled.div<LabelTextProps>`
  ${({ size }) => (size === 'small' ? Typography.labelMedium : Typography.labelLarge)};
  ${Typography.textSemiStrong};
  &:not(:empty) {
    margin-bottom: ${rem(5)};
  }
  color: ${themeColor(BaseColor.shade_60)};
`

export const Caption = styled.span`
  display: block;
  ${Typography.labelMedium};
  ${Typography.textRegular};
  color: ${themeColor(BaseColor.shade_50)};
`

export const Error = styled(Caption)`
  color: ${themeColor(Color.danger)};
`

interface LabelProps {
  fixedCaption?: boolean
  isDisabled?: boolean
}

export const Label = styled.label<LabelProps>`
  display: block;

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      opacity: 0.4;
      pointer-events: none;
      touch-action: none;

      ${InputStyled} {
        opacity: 1;
      }
    `}

  ${({ fixedCaption }) =>
    fixedCaption
      ? css`
          position: relative;
          padding-bottom: ${spacing(1.25)};
          margin-bottom: ${spacing(0.5)};

          ${Caption} {
            position: absolute;
            bottom: 0;
            left: 0;
            max-width: 100%;
            ${textEllipsis};
          }
        `
      : css`
          ${Caption} {
            margin-top: ${rem(8)};
          }
        `}
`
